import DynamicComponent from "./DynamicComponent";
import type { DynamicComponentProps } from "./DynamicComponent.d";

export { DynamicComponent };
export type { DynamicComponentProps };
export { renderDynamicComponent } from "./DynamicComponent";
